function AuthHowItWorks() {
  const steps = [
    {
      number: "1",
      title: "Secure Tagging",
      desc: "Apply unique, tamper-evident identifiers to each product during manufacturing",
    },
    {
      number: "2",
      title: "Blockchain Registration",
      desc: "Register product identity on immutable blockchain ledger",
    },
    {
      number: "3",
      title: "Consumer Verification",
      desc: "Consumers scan tags to instantly verify authenticity",
    },
    {
      number: "4",
      title: "Real-time Monitoring",
      desc: "Track verification attempts and detect counterfeit patterns",
    },
  ];

  return (
    <section className="py-20 px-4 sm:px-6 lg:px-8 bg-gradient-to-br from-gray-50 to-blue-50">
      <div className="max-w-7xl mx-auto">

        {/* Heading */}
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold text-black mb-6">
            How It Works
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Simple implementation, powerful protection
          </p>
        </div>

        {/* Steps Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {steps.map((step, index) => (
            <div key={index} className="relative">

              {/* Card */}
              <div className="bg-white rounded-2xl p-6 shadow-lg border border-gray-200 h-full hover:shadow-xl transition-shadow">

                {/* Number Badge */}
                <div className="w-12 h-12 bg-blue-600 rounded-full flex items-center justify-center mb-4 text-white font-bold text-xl">
                  {step.number}
                </div>

                {/* Title */}
                <h3 className="text-xl font-bold text-black mb-3">
                  {step.title}
                </h3>

                {/* Description */}
                <p className="text-gray-600">
                  {step.desc}
                </p>
              </div>

              {/* Connector line — only between cards, only on lg screens */}
              

            </div>
          ))}
        </div>

      </div>
    </section>
  );
}

export default AuthHowItWorks;